import React from 'react';
import type { FC, ReactNode } from 'react';
import classNames from 'classnames';

// Components
import FloatingPanel from '../../../../components/tooltips/FloatingPanel';
import PopupPanelMouseManager from '../../../../components/popupPanel/PopupPanelMouseManager';

// Constants
import { PopupIds } from '../../../../components/popupPanel/popupConstants';
import { TooltipPositions } from '../../../../components/tooltips/tooltipConstants';

type DatePickerContainerProps = {
    children: ReactNode;
    gridSize: number;
    show: boolean;
};

const DatePickerContainer: FC<DatePickerContainerProps> = ({ children, gridSize, show }) => {
    if (!show) return null;

    return (
        <FloatingPanel
            selector=".Table.selected .handsontable-input-holder"
            className={classNames('TableDateTimePicker', 'className', 'light')}
            position={TooltipPositions.BOTTOM}
            gridSize={gridSize}
            pollPosition
        >
            <PopupPanelMouseManager
                visible
                popupId={PopupIds.TABLE_DATE_TIME_PICKER}
                ignoredClicksSelector=".Toolbar"
                closePopup={() => {}}
            >
                <div className="popup-content" data-table-util>
                    {children}
                </div>
            </PopupPanelMouseManager>
        </FloatingPanel>
    );
};

export default DatePickerContainer;
